<template>
  <div>
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fieldsTGrupo"
            :orderby="sortBy"
            :actions="actionsTGrupo"
            addFilter
            :items="listagemFuncoes"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          ></fccTable>
        </div>
      </div>
      <fccModal
        centered
        idModal="addFieldModal"
        size="lg"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <form
          autocomplete="off"
          @submit.prevent="criarTFuncao.idfuncao === 0 ? adicionarTFuncao() : editandoTFuncao()"
        >
          <div class="row">
            <div class="col-sm-12">
              <fccInput extraClasses="inputLabel" required v-model="criarTFuncao.titulofuncao"
                >Título da Função</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <input type="hidden" v-model="criarTFuncao.idtipoarquivo" />
              <fccInput extraClasses="inputLabel" required v-model="criarTFuncao.funcao"
                >Nome da Função</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <input type="hidden" v-model="criarTFuncao.idtipoarquivo" />
              <fccInput extraClasses="inputLabel" required v-model="criarTFuncao.endpoint"
                >EndPoint</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <input type="hidden" v-model="criarTFuncao.projeto" />
              <fccInput extraClasses="inputLabel" required v-model="criarTFuncao.projeto"
                >Projeto</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-4">
              <span
                ><toggle-button v-model="criarTFuncao.fldeclaracao" :sync="true" /> Tem
                declaração?</span
              >
            </div>
          </div>
          <div class="row mb-4" v-if="criarTFuncao.fldeclaracao">
            <div class="col mt-3"><fcc-editor v-model="criarTFuncao.declaracao"></fcc-editor></div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-4">
              <span
                ><toggle-button v-model="criarTFuncao.flprossegue" :sync="true" /> Permite
                prosseguir?</span
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </form>
      </fccModal>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Cadastro de funções',
      titlePDF: 'Lista de Cadastro de funções',
      titleModal: '',
      fieldsTGrupo: [
        { key: 'idfuncao', label: 'Id', sortable: false },
        { key: 'titulofuncao', label: 'Título', sortable: true },
        { key: 'actions', label: '' }
      ],
      c: {
        idfuncao: 0,
        titulofuncao: '',
        funcao: '',
        endPoint: '',
        projeto: '',
        flDeclaracao: true,
        declaracao: '',
        flProssegue: true
      },
      itemPorPage: '100',
      listagemFuncoes: [],
      criarTFuncao: {},
      actionsTGrupo: [
        {
          button: true,
          funcaoButton: 'editFuncao',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteFuncao',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  methods: {
    listarTValidacao: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      this.validacaoDocumentos()
        .then((response) => {
          this.listagemFuncoes = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    deleteFuncao: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlPublicacao +
                'ValidacaoDocumentos/ExcluirValidacaoDocumentos/' +
                item.idtipoarquivo,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarTValidacao()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    editFuncao: function (_, item) {
      this.criarTFuncao = item
      this.titleModal = 'Editar função'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    addField: function () {
      this.criarTFuncao = {}
      this.criarTFuncao.idfuncao = 0
      this.titleModal = 'Adicionar função'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    editandoTFuncao: function () {
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .put(
          this.baseUrlPublicacao + 'ValidacaoDocumentos/AlterarValidacaoDocumentos',
          this.criarTFuncao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarTValidacao()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    adicionarTFuncao: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlPublicacao + 'ValidacaoDocumentos/InserirValidacaoDocumentos',
          this.criarTFuncao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarTValidacao()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted: function () {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.listarTValidacao()
  }
}
</script>
